import React from 'react'
import { Button } from '@mui/material'
const SalesAndBalance = () => {
  return (
    <div style={{width:"100%",backgroundColor:"#F3F4F8"}}>
      <div style={{ display: "flex", justifyContent: "center",flexDirection:"column" }}>
        <span>
          <div style={{ padding:20, fontSize:30,fontWeight:"bold" }}>
            <span>Balance</span> 
          </div>     
        </span>
        <div style={{display:"flex",backgroundColor:"white",padding:30,flexDirection:"column",alignItems:"center",justifyContent:"space-around",width:"90%"}}>
          <div style={{width:"98%",marginTop:40}}>
            <h3>Sales and Balance Table</h3>
            <p>This is a test to see if the component renders</p>
            {/* <components.Table.salesAndBalanceTable/> */}
          </div>
          <div style={{ display: "flex", justifyContent: "center",width:"100%", marginTop: 10}}>
            <div style={{display:"flex",flexDirection:"row",height:100,width:"95%",alignItems:"center",justifyContent:"space-between",padding:30}}>
              <span style={{fontSize:24}}>
                Tokenized Data Sales
              </span>            
              <Button variant='contained'>Download Sales Report</Button>      
            </div> 
          </div>
          <div style={{width:"98%",marginTop:40}}>
            <h4>Line Chart</h4>
            <p>Chart component would go here</p>
            {/* <components.Charts.lineChart/> */}
          </div>  
        </div>
      </div>
    </div>
  );
};

export default SalesAndBalance